import { normalize } from "normalizr";
import { push } from "react-router-redux";

import Config from "../../config";

import * as apiHelper from "../../helpers/api";
import { truncateString } from "../../helpers/string";

import { wevoSchema } from "../../schemas";
import { requestWithAuth } from "../../utils/request";

import * as notificationActions from "../notifications/actions";
import { trackerActions } from "../tracker";
import { ConfigureProjectEvents } from "../tracker/event-names";

import {
    LAUNCH_WEVO_FAILURE,
    LAUNCH_WEVO_REQUEST,
    LAUNCH_WEVO_SUCCESS
} from "./types";

const API_URL = apiHelper.getApiUrl();

export function fetchWevoIfNeeded(wevoId) {
    return (dispatch, getState) => {
        const { entities } = getState();
        const { wevos } = entities;

        if (
            !wevos[wevoId] ||
            !wevos[wevoId].results ||
            !wevos[wevoId].ctas ||
            !wevos[wevoId].pages ||
            !wevos[wevoId].devices ||
            !wevos[wevoId].audiences
        ) {
            dispatch(fetchWevo(wevoId));
        }
    };
}

export function fetchWevo(wevoId) {
    return dispatch => {
        return requestWithAuth(dispatch, http =>
            http.get(`${API_URL}/wevos/${wevoId}`)
        )
            .then(({ data }) => {
                const { entities } = normalize(data, wevoSchema);
                dispatch({
                    type: "RECEIVE_ENTITIES",
                    entities
                });
            })
            .catch(err => console.error(err));
    };
}

export function launchWevo(wevo, onSuccessUrl) {
    return dispatch => {
        dispatch({
            type: LAUNCH_WEVO_REQUEST,
            wevoId: wevo.id
        });
        const trackerObject = {
            wevo_id: wevo.id
        };
        dispatch(
            trackerActions.trackEvent(
                ConfigureProjectEvents.DID_ATTEMPT_PROJECT_LAUNCH,
                trackerObject
            )
        );
        return requestWithAuth(dispatch, http =>
            http.post(`${API_URL}/wevos/${wevo.id}/launch`)
        )
            .then(() => {
                dispatch(push(onSuccessUrl));
                dispatch({
                    type: LAUNCH_WEVO_SUCCESS,
                    wevoId: wevo.id
                });
                dispatch(
                    trackerActions.trackEvent(
                        ConfigureProjectEvents.DID_SUCCESSFULLY_LAUNCH_PROJECT,
                        trackerObject
                    )
                );

                const wevoName = truncateString(
                    wevo.name,
                    Config.test().testNameTruncateLength
                );
                dispatch(
                    notificationActions.notifySuccess(
                        `${wevoName} is now Running. Check back soon for results.`
                    )
                );
            })
            .catch(err => {
                dispatch(
                    trackerActions.trackEvent(
                        ConfigureProjectEvents.DID_RECEIVE_PROJECT_REVIEW_ERROR,
                        {
                            ...trackerObject,
                            error_message: err.toString()
                        }
                    )
                );
                dispatch({
                    type: LAUNCH_WEVO_FAILURE,
                    wevoId: wevo.id,
                    err
                });
            });
    };
}



// WEBPACK FOOTER //
// ./src/modules/wevos/actions.js